// src/App.js
import { useState } from "react";
import "./mobile.css";
import HomePage from "./components/HomePages/HomePage";
import OurTeam from "./components/HomePages/OurTeam";
import LoginSignup from "./components/LoginSignup/LoginSignup";
import CreateProfile from "./components/LoginSignup/CreateProfile";
import Calendar from "./components/UserCalendar/Calendar";
import BusinessHome from "./components/BusinessHome/BusinessHome";
import BusinessCalendar from "./components/BusinessCalendar/BusinessCalendar";
import BusinessCRMDash from "./components/BusinessCRMDash/BusinessCRMDash";
import BusinessProfile from "./components/BusinessProfile/BusinessProfile";
import BusinessSampleCRM from "./components/BusinessCRMAnalytics/BusinessSampleCRM";
import BusinessEventManagement from "./components/BusinessEventManagement/BusinessEventManagement";
import AdminHome from "./components/AdminHome/AdminHome";
import AdminCalendar from "./components/AdminCalendar/AdminCalendar";
import AdminEventManagement from "./components/AdminEventManagement/AdminEventManagement";
import AdminKPIDash from "./components/AdminKPIDash/AdminKPIDash";
import AdminBusinessManagement from "./components/AdminBusinessManagement/adminBusinessManagement";
import AdminUserManagement from "./components/AdminUserManagement/adminUserManagement";
import AdminSampleKPI from "./components/AdminKPIAnalytics/AdminSampleKPI";
import AdminKpi1A from "./components/AdminKPIAnalytics/AdminKpi1A";
import AdminKpi1B from "./components/AdminKPIAnalytics/AdminKpi1B";
import AdminKpi1C from "./components/AdminKPIAnalytics/AdminKpi1C";
import AdminKpi2A from "./components/AdminKPIAnalytics/AdminKpi2A";
import AdminKpi2B from "./components/AdminKPIAnalytics/AdminKpi2B";
import AdminKpi2C from "./components/AdminKPIAnalytics/AdminKpi2C";
import UserMyEvents from "./components/UserMyEvents/UserMyEvents";
import AddEvent from "./components/AddEvent/AddEvent";
import Connections from "./components/UserConnections/Connections";
import UserProfile from "./components/UserProfile/UserProfile";
import Notifications from "./components/UserNotification/Notifications";
 
 
function App() {
  // Track which screen the user is on
  const [currentView, setCurrentView] = useState(() => sessionStorage.getItem("currentView") || 'home');

  const handleViewSelect = (view, data = {}) => {
    sessionStorage.setItem("currentView", view);
    setCurrentView(view);
    setViewData(data);
  };
 
  // Track who is logged in (null = nobody)
  const [currentUser, setCurrentUser] = useState(() => {
    const saved = sessionStorage.getItem("currentUser");
    return saved ? JSON.parse(saved) : null;
  });

  const handleSetCurrentUser = (user) => {
    sessionStorage.setItem("currentUser", JSON.stringify(user));
    setCurrentUser(user);
  };
 
  // Add event return view state to determine where to navigate after adding an event
  const [addEventReturnView, setAddEventReturnView] = useState('business');
  const navigateToAddEvent = (returnView) => {
    setAddEventReturnView(returnView);
    handleViewSelect('add-event');
  };

  // Edit event from calendar
  const [viewData, setViewData] = useState({});
 
  return (
    <>
      {/*HOME PAGES/DEFAULT */}
      {currentView === 'home' && (
        <HomePage onViewSelect={handleViewSelect} />
      )}
      {currentView === 'team' && (
        <OurTeam onViewSelect={handleViewSelect} />
      )}
      {currentView === "loginSignup" && (
        <LoginSignup
          onViewSelect={handleViewSelect}
          onLogin={handleSetCurrentUser}
        />
      )}
      {/*{currentView === 'login' && ( 
        <TBD Setup Later />
      )} */}
      {currentView === 'create' && (
        <CreateProfile onViewSelect={handleViewSelect} />
      )}
 
      {/*USER PAGES*/}
      {currentView === "user" && (
        <Calendar currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
 
      {currentView === "my-events" && (
        <UserMyEvents currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
 
      {currentView === "connections" && (
        <Connections currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
 
      {currentView === "user-profile" && (
        <UserProfile currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
 
      {currentView === "user-management" && (
        <AdminUserManagement currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
      {currentView === "notifications" && (
        <Notifications currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
 
 
      {/*BUSINESS PAGES*/}
      {currentView === 'businessHome' && (
        <BusinessHome  currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
      {/* Business calendar */}
      {currentView === "business" && (
        <BusinessCalendar
          currentUser={currentUser}
          onViewSelect={handleViewSelect}
        />
      )}
      {currentView === 'businessCRMDash' && (
        <BusinessCRMDash currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
      {currentView === 'detailed-crm' && (
        <BusinessSampleCRM  currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
      {currentView === 'event-management' && (
        <BusinessEventManagement 
          currentUser={currentUser} 
          onViewSelect={handleViewSelect}
          onAddEvent={() => navigateToAddEvent('business')}
          editEvent={viewData.editEvent}
        />
      )}
      {currentView === 'business-profile' && (
        <BusinessProfile currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
      {/* {currentView === 'add-event' && (
        <AddEvent currentUser={currentUser} onViewSelect={handleViewSelect} />
      )} */}
      {currentView === 'business-management' && (
        <AdminBusinessManagement currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
 
      {/*ADMIN PAGES*/}
      {currentView === 'admin' && (
        <AdminHome  currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
      {currentView === 'adminCalendar' && (
        <AdminCalendar 
          currentUser={currentUser} 
          onViewSelect={handleViewSelect} 
          onAddEvent={() => navigateToAddEvent('adminEventManagement')}
        />
      )}
      {currentView === 'adminEventManagement' && (
        <AdminEventManagement 
          currentUser={currentUser} 
          onViewSelect={handleViewSelect} 
          onAddEvent={() => navigateToAddEvent('adminEventManagement')}
          editEvent={viewData.editEvent}
        />
      )}
      {currentView === 'add-event' && (
        <AddEvent
          currentUser={currentUser}
          onViewSelect={handleViewSelect}
          returnView={addEventReturnView}
        />
      )}
      {currentView === 'adminKPIDash' && (
        <AdminKPIDash currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
      {currentView === 'detailed-analytic' && (
        <AdminSampleKPI currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
      {currentView === 'kpi-1A' && (
        <AdminKpi1A currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
      {currentView === 'kpi-1B' && (
        <AdminKpi1B currentUser={currentUser}  onViewSelect={handleViewSelect} />
      )}
      {currentView === 'kpi-1C' && (
        <AdminKpi1C currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
      {currentView === 'kpi-2A' && (
        <AdminKpi2A currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
      {currentView === 'kpi-2B' && (
        <AdminKpi2B currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
      {currentView === 'kpi-2C' && (
        <AdminKpi2C currentUser={currentUser} onViewSelect={handleViewSelect} />
      )}
    {/*
      {currentView === 'kpi - 1A' && (
        <AdminSampleKPI onViewSelect={handleViewSelect} />
      )}
      {currentView === 'kpi - 1B' && (
        <AdminSampleKPI onViewSelect={handleViewSelect} />
      )}
      {currentView === 'kpi - 1C' && (
        <AdminSampleKPI onViewSelect={handleViewSelect} />
      )}
      {currentView === 'kpi - 1A' && (
        <AdminSampleKPI onViewSelect={handleViewSelect} />
      )}
      {currentView === 'kpi - 1B' && (
        <AdminSampleKPI onViewSelect={handleViewSelect} />
      )}
      {currentView === 'kpi - 1C' && (
        <AdminSampleKPI onViewSelect={handleViewSelect} />
      )}
    */}
      
    </>
  );
}
 
export default App;